import { onLoad} from "Core/Events";
import * as SmartPhoto from "smartphoto/js/smartphoto";

export const SmartPhotoModule = (() => {

    const Selector = {
        SMART_PHOTO_ITEM: '.js-smartphoto',
    };

    onLoad(init);

    function init() {
        new SmartPhoto(Selector.SMART_PHOTO_ITEM, {
            forceInterval: 1000,
        });
    }

})();import { onLoad} from "Core/Events";
import * as SmartPhoto from "smartphoto/js/smartphoto";

export const SmartPhotoModule = (() => {

    const Selector = {
        SMART_PHOTO_ITEM: '.js-smartphoto',
    };

    onLoad(init);

    function init() {
        new SmartPhoto(Selector.SMART_PHOTO_ITEM, {
            forceInterval: 1000,
        });
    }

})();